import placeholder from 'assets/icons/Header/Group 27.svg';
import { isPhotoTokenFailed, markPhotoTokenFailed } from 'hooks/usePhotos';

/** Build same-origin URL for profile photo token (cookie auth via <img>). */
export function profilePhotoSrc(token?: string | null): string | null {
  const value = token?.trim();
  if (!value) return null;
  if (value.startsWith('blob:') || value.startsWith('data:')) return value;
  if (value.startsWith('http://') || value.startsWith('https://')) return value;
  if (value.startsWith('/assets/') || value.startsWith('/src/')) return value;

  if (value.includes('/get_image/')) {
    const match = value.match(/\/get_image\/([^/?]+)/);
    const extracted = match?.[1];
    if (!extracted || isPhotoTokenFailed(extracted)) return null;
    return value.startsWith('/v1/') ? value : `/v1${value.startsWith('/') ? value : `/${value}`}`;
  }

  if (isPhotoTokenFailed(value)) return null;
  return `/v1/get_image/${value}`;
}

export function profilePhotoFallback(): string {
  return placeholder;
}

export function markProfilePhotoFailed(token?: string | null): void {
  const value = token?.trim();
  if (!value) return;
  const match = value.match(/\/get_image\/([^/?]+)/);
  markPhotoTokenFailed(match?.[1] || value);
}
